var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5681 28.0431C3.83767 28.7231 3.89769 29.4682 3.74043 30.1826L1.78793 36.2143C1.72502 36.5202 1.74129 36.837 1.83519 37.1349C1.92909 37.4327 2.09751 37.7016 2.32449 37.9161C2.55146 38.1306 2.82947 38.2836 3.13213 38.3605C3.4348 38.4374 3.7521 38.4357 4.05393 38.3556L10.3111 36.5259C10.9852 36.3922 11.6834 36.4507 12.3259 36.6946C16.2408 38.5229 20.6756 38.9096 24.8479 37.7868C29.0201 36.6639 32.6618 34.1035 35.1302 30.5573C37.5987 27.0111 38.7353 22.707 38.3396 18.4044C37.944 14.1019 36.0414 10.0773 32.9676 7.0408C29.8937 4.0043 25.8462 2.15101 21.5391 1.80792C17.232 1.46482 12.9422 2.65397 9.42641 5.16556C5.91064 7.67715 3.39491 11.3498 2.32307 15.5354C1.25124 19.7211 1.69218 24.1509 3.5681 28.0431Z",
    stroke: "#4771FE",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViber);
export default __webpack_public_path__ + "static/media/viber.adf3cd70632d834c562b2764c6015695.svg";
export { ForwardRef as ReactComponent };